import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ConfigurationAssayLaboratoryResponse } from '@/modules/configurationModule/detail/local-assays/assays-laboratory/services/configuration-assay-laboratory/configuration-assay-laboratory.dto'
import { configurationAssayLaboratoryService } from '@/modules/configurationModule/detail/local-assays/assays-laboratory/services/configuration-assay-laboratory/configuration-assay-laboratory.service'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { store } from '@/store/store'

export const columnsDefLocalAssaysAssaysLaboratoryGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.assay'),
            field: 'assay.name',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.assayGroup'),
            field: 'assay.assaygroup.name',
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        // TODO: Display next columns when external control development
        /* {
        type: AgGridColumnType.TEXT,
        headerName: i18n.tc('configuration.grid.externalControl'),
        field: 'externalControl',
        minWidth: 120,
        flex: 1,
        suppressSizeToFit: true
    },
    {
        type: AgGridColumnType.TEXT,
        headerName: i18n.tc('configuration.grid.controlType'),
        field: 'controlType',
        minWidth: 120,
        flex: 1,
        suppressSizeToFit: true
    }, */
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.ownCatalogue'),
            field: 'localCatalog',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.accredited'),
            field: 'accreditation',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('global.pathologicalReport'),
            field: 'visibilityReport',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface ConfigurationLocalAssaysAssaysLaboratoryGridState extends CrudModelPaginatorLaboratory<ConfigurationAssayLaboratoryResponse> {
    service: typeof configurationAssayLaboratoryService
    laboratoryId: number
}
export const initialConfigurationLocalAssaysAssaysLaboratoryGridState =
    (): ConfigurationLocalAssaysAssaysLaboratoryGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.assays.assays',
        columnsDef: columnsDefLocalAssaysAssaysLaboratoryGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationAssayLaboratoryService, store.getters.labId),
        service: configurationAssayLaboratoryService,
        laboratoryId: store.getters.labId
    })
